import NfcCardFailures from './NfcCardFailures';

export default NfcCardFailures;
